// Both unread count owners (web NotificationsProvider, mobile NotificationCountProvider) apply a
// read of the server's total only when no local count change landed while it was in flight.

/** A dropped read reads again up to this many reads per call, so a burst cannot loop it forever */
export const MAX_UNREAD_TOTAL_READS = 3;

/**
 * Reads the total until a read lands with no change to countVersion during it. Null when a read
 * fails or every read was dropped, so the caller keeps its own count until the next re-read.
 */
export async function readUnreadTotal(
  requestTotal: () => Promise<Response>,
  countVersion: () => number,
): Promise<number | null> {
  for (let read = 0; read < MAX_UNREAD_TOTAL_READS; read++) {
    const started = countVersion();
    // Sequential on purpose: a read starts only once the one before it was dropped
    const total = await readOnce(requestTotal);
    if (total === null || countVersion() === started) return total;
  }
  return null;
}

async function readOnce(requestTotal: () => Promise<Response>): Promise<number | null> {
  try {
    const res = await requestTotal();
    if (!res.ok) return null;
    const data: { unreadCount?: number } = await res.json();
    return data.unreadCount ?? 0;
  } catch {
    // Non-critical: the count keeps its value until the next read
    return null;
  }
}
